<template>
  <div class="feature flex align-center">
    <h4 class="flex align-center c-primary fw-medium">
      <icon class="inline" colour="#B95A25" width="36" height="36">
        <slot name="icon"/>
      </icon>
      <slot name="text"/>
    </h4>
  </div>
</template>

<script>
export default {
  name: 'Feature'
}
</script>



// WEBPACK FOOTER //
// src/components/ui/Feature.vue